import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="tc-container">
      <div className="tc-content">
        <h1 className="tc-title">Terms & Conditions</h1>
        <p className="tc-last-modified">Last modified : January 2026</p>

        <p className="tc-intro">
          Welcome to True Renewables, your trusted partner for end-to-end solar EPC and
          renewable energy solutions. By accessing or using our website (https://truerenewables.in/) 
          or engaging with our services, you agree to the terms outlined below.
        </p>

        <div className="tc-section">
          <h2>1. General Terms</h2>
          <p>
            By using this website, you confirm that you are at least 18 years old or have
            parental consent. If you disagree with any part of these Terms, please stop using
            our website or services. These Terms apply to all visitors, customers, and users of
            our website.
          </p>
        </div>

        <div className="tc-section">
          <h2>2. Use Of The Website</h2>
          <p>Please use our website responsibly and only for lawful purposes. You agree not to:</p>
          <ul>
            <li>Copy or reuse our content without permission.</li>
            <li>Upload viruses, spam, or harmful code.</li>
            <li>Submit false or misleading information.</li>
          </ul>
        </div>

        <div className="tc-section">
          <h2>3. Our Services</h2>
          <p>
            We provide EPC (Engineering, Procurement & Construction) solutions for solar,
            captive, and renewable energy projects. Service availability, timelines, and prices
            may vary and can be updated at any time without prior notice.
          </p>
        </div>

        <div className="tc-section">
          <h2>4. Intellectual Property</h2>
          <p>
            All website content — including text, images, logos, designs, and graphics — is
            owned by True Renewables and protected by copyright and trademark laws. You
            may view or download materials for personal use only. Commercial use without
            written consent is strictly prohibited.
          </p>
        </div>

        <div className="tc-section">
          <h2>5. Third-Party Links</h2>
          <p>
            Our website may include links to external websites for your convenience. We are
            not responsible for the content or privacy practices of these third-party sites.
          </p>
        </div>

        <div className="tc-section">
          <h2>6. Payments & Refunds</h2>
          <p>
            If you make payments through our platform (for solar services, subscriptions, or
            installations):
          </p>
          <ul>
            <li>All transactions are processed through secure, verified gateways.</li>
            <li>Prices are subject to change without prior notice.</li>
            <li>Refunds and cancellations follow our official Refund Policy listed on this website.</li>
          </ul>
        </div>

        <div className="tc-section">
          <h2>7. Limitation Of Liability</h2>
          <p>
            While we strive for accuracy, True Renewables is not liable for any losses or
            damages arising from the use or inability to use our website, services, or linked
            resources.
          </p>
        </div>

        <div className="tc-section">
          <h2>8. Indemnity</h2>
          <p>
            You agree to indemnify and hold harmless True Renewables, its employees, and
            partners against any claims arising from your misuse of the website or violation of
            these Terms.
          </p>
        </div>

        <div className="tc-section">
          <h2>9. Privacy</h2>
          <p>
            We care about your privacy. Please refer to our Privacy Policy for details on how we
            collect, store, and use your personal data.
          </p>
        </div>

        <div className="tc-section">
          <h2>10. Updates To These Terms</h2>
          <p>
            We may update these Terms from time to time. The latest version will always be
            available here, with the "Last Updated" date displayed above.
          </p>
        </div>

        <div className="tc-section">
          <h2>11. Contact Us</h2>
          <p>If you have any questions about these Terms, please reach out to us:</p>
          <ul>
            <li><strong>Email:</strong> <a href="mailto:Care@truerenewables.in">Care@truerenewables.in</a></li>
            <li>
              <strong>Address:</strong> Plot No 1/C, Sy No 83/1, Raidurgam, Knowledge City Road, Panmaktha,
              Hyderabad – 500032
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
